import { render } from "./MailPreview.vue?vue&type=template&id=cf206878&scoped=true"
import script from "./MailPreview.vue?vue&type=script&lang=js"
export * from "./MailPreview.vue?vue&type=script&lang=js"

import "./MailPreview.vue?vue&type=style&index=0&id=cf206878&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf206878"

export default script